import { axiosHelper } from 'Services/AxiosHelper';
import { OnGetCustomerInfoModel } from 'Models';
import { onGetCustomerInfoReqBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'RI.OnGetCustomerInfo';

const onGetCustomerInfo = async (params: onGetCustomerInfoReqBodyData): Promise<OnGetCustomerInfoModel> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default onGetCustomerInfo;
